import { render, staticRenderFns } from "./IntegrationTile.vue?vue&type=template&id=9a95bbc0&scoped=true&"
import script from "./IntegrationTile.vue?vue&type=script&lang=js&"
export * from "./IntegrationTile.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationTile.vue?vue&type=style&index=0&id=9a95bbc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a95bbc0",
  null
  
)

export default component.exports